import { render, staticRenderFns } from "./AppWidget.vue?vue&type=template&id=5cd960bf&"
import script from "./AppWidget.vue?vue&type=script&lang=js&"
export * from "./AppWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports